import React from 'react';

import AccessAlarmIcon from '@mui/icons-material/AccessAlarm';
import HourglassBottomOutlinedIcon from '@mui/icons-material/HourglassBottomOutlined';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import { Box } from '@mui/material';

import Text from 'components/Text';

interface EventInfoProps {
  totalParticipants: number;
  duration: string;
  time?: string;
}

const EventInfo: React.FC<EventInfoProps> = ({ totalParticipants, duration, time }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        width: '100%',
        justifyContent: 'space-evenly',
        padding: 1,
      }}
    >
      {time && (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
          <AccessAlarmIcon fontSize="small" color="primary" />
          <Text size="small">{time}</Text>
        </Box>
      )}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
        <HourglassBottomOutlinedIcon fontSize="small" color="primary" />
        <Text size="small">{duration}</Text>
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
        <PeopleAltIcon fontSize="small" color="primary" />
        <Text size="small">{totalParticipants} inscritos</Text>
      </Box>
    </Box>
  );
};

export default EventInfo;
